var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("Groups", {
        ref: "groups",
        attrs: {
          feature: "cellscope",
          groups: _vm.groups,
          groupSelector: "group",
          groupCopyFunction: g => _vm.GroupMaintenanceExtension.fromJS(g),
          groupInitFunction: () => _vm.initGroup(),
          groupSaveFunction: g => _vm.saveGroup(g),
          groupDeleteFunction: g => _vm.deleteGroup(g),
          canDeleteGroups: true,
          showPinnedGroupsOnly: false
        },
        scopedSlots: _vm._u(
          [
            {
              key: "editModal",
              fn: function({ availableSalutations, allUsers, setRef }) {
                return [
                  _vm._t("editModal", function() {
                    return [
                      _c("GroupsForMaintenanceEditModal", {
                        ref: setRef,
                        attrs: {
                          groups: _vm.groups,
                          availableSalutations: availableSalutations,
                          allUsers: allUsers,
                          groupSelector: "group",
                          groupCopyFunction: g =>
                            _vm.GroupMaintenanceExtension.fromJS(g),
                          groupSaveFunction: g => _vm.saveGroup(g)
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "editModalTitle",
                              fn: function() {
                                return [_vm._t("editModalTitle")]
                              },
                              proxy: true
                            },
                            {
                              key: "editModalTabs",
                              fn: function({ group }) {
                                return [
                                  _vm._t("editModalTabs", null, {
                                    group: group
                                  })
                                ]
                              }
                            },
                            {
                              key: "generalAfter",
                              fn: function({ group }) {
                                return [
                                  _vm._t("generalAfter", null, { group: group })
                                ]
                              }
                            },
                            {
                              key: "externalUserSelectModalTabs",
                              fn: function() {
                                return [_vm._t("externalUserSelectModalTabs")]
                              },
                              proxy: true
                            },
                            {
                              key: "userButtonsBefore",
                              fn: function({ groupUser }) {
                                return [
                                  _vm._t("userButtonsBefore", null, {
                                    groupUser: groupUser
                                  })
                                ]
                              }
                            },
                            {
                              key: "externalUserButtonsBefore",
                              fn: function({ groupUserExternal }) {
                                return [
                                  _vm._t("externalUserButtonsBefore", null, {
                                    groupUserExternal: groupUserExternal
                                  })
                                ]
                              }
                            },
                            {
                              key: "selectedExternalUserButtonsBefore",
                              fn: function({ groupUserExternals }) {
                                return [
                                  _vm._t(
                                    "selectedExternalUserButtonsBefore",
                                    null,
                                    { groupUserExternals: groupUserExternals }
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ]
                  })
                ]
              }
            },
            {
              key: "actionsBefore",
              fn: function({ group }) {
                return [_vm._t("actionsBefore", null, { group: group })]
              }
            },
            {
              key: "actionsAfter",
              fn: function({ group }) {
                return [_vm._t("actionsAfter", null, { group: group })]
              }
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }